import React from "react";
import { Typography, Box, CircularProgress } from "@material-ui/core";
import { css } from "@emotion/css";
import { usePublishedQuestionnaire } from "../queries";
import { primaryText } from "../types/common";

const PublishedQuestionnaireViewer: React.VFC<{ id: number }> = ({ id }) => {
  const { data, isLoading, error } = usePublishedQuestionnaire(id);

  if (isLoading) return <CircularProgress />;
  if (error) return <Typography style={{ color: "#f44336" }}>Failed to load published questionnaire</Typography>;
  if (!data) return null;

  return (
    <div className={styles.container}>
      <Box className={styles.header}>
        <Typography variant="h6">{data.name}</Typography>
        <Typography variant="caption" color="textSecondary" display="block">
          Published {data.published_at ? new Date(data.published_at).toLocaleString() : "N/A"} by {data.published_by ?? "N/A"}
        </Typography>
      </Box>

      {data.pages.map((page, pi) => (
        <Box key={pi} className={styles.page}>
          <Typography variant="subtitle2" color="textSecondary">
            Page {pi + 1}{page.title ? `: ${primaryText(page.title)}` : ""}
          </Typography>
          {page.parts.map((part, partIdx) => (
            <Box key={partIdx} className={styles.part}>
              {part._type === "question" && part.question && (
                <Typography variant="body2">
                  {primaryText(part.question.question ?? {})} <Typography component="span" variant="caption" color="textSecondary">({part.question.feel_id})</Typography>
                </Typography>
              )}
              {part._type === "question_group" && part.question_group && (
                <Typography variant="body2">
                  [Group] {part.question_group.name ?? primaryText(part.question_group.title ?? {})}
                </Typography>
              )}
            </Box>
          ))}
        </Box>
      ))}
    </div>
  );
};

export default PublishedQuestionnaireViewer;

const styles = {
  container: css`
    padding: 16px;
    overflow-y: auto;
    height: 100%;
    box-sizing: border-box;
  `,
  header: css`
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e0e0e0;
  `,
  page: css`
    margin-bottom: 12px;
  `,
  part: css`
    padding: 2px 0 2px 12px;
  `,
};
